import { forwardRef } from "react";
import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import type { LinkProps } from "react-router-dom";
import { getButtonClassName } from "./Button";
import type { ButtonVariant, ButtonSize } from "./Button";

export interface LinkButtonProps extends Omit<LinkProps, "className"> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  className?: string;
  children: ReactNode;
}

export const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  ({ variant = "primary", size = "md", fullWidth = false, className, children, ...props }, ref) => {
    const linkClassName = getButtonClassName(variant, size, {
      fullWidth,
      className,
    });

    return (
      <Link ref={ref} className={linkClassName} {...props}>
        {children}
      </Link>
    );
  },
);

LinkButton.displayName = "LinkButton";
